import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UltimatePagination from 'react-ultimate-pagination-bootstrap-4';

import {
  getDuplicateCompaniesPage,
  getDuplicateCompaniesPageCount
} from '../../store/selectors/duplicates';
import { retrieveCompaniesDuplicates } from 'bundles/contact/index/store/actions/duplicates';

export function DuplicatesPagination({ currentPage, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;

  return (
    <div className="text-center">
      <UltimatePagination
        currentPage={currentPage}
        totalPages={totalPages}
        onChange={onPageChange}
      />
    </div>
  );
}

DuplicatesPagination.propTypes = {
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  onPageChange: PropTypes.func
};

const mapStateToProps = state => ({
  currentPage: getDuplicateCompaniesPage(state),
  totalPages: getDuplicateCompaniesPageCount(state)
});

const mapDispatchToProps = {
  onPageChange: retrieveCompaniesDuplicates
};

export default connect(mapStateToProps, mapDispatchToProps)(DuplicatesPagination);
